// extracted by mini-css-extract-plugin
export default {"stripeFormWrapper":"style_stripeFormWrapper__ErueY","stripeSubmitButton":"style_stripeSubmitButton__wKMI0"};